export default __webpack_public_path__ + "static/media/not_fav_icon.dd9e1276.png";